import { lazy, Suspense, useEffect, useState } from 'react';
import { registerToastHost, toastHostReady } from '@/lib/toast';

const Toaster = lazy(() => import('@/components/ui/sonner').then((m) => ({ default: m.Toaster })));

// Its effect runs after sonner's own subscription effect (child effects fire
// first), so the wrapper can safely report the toaster as ready here.
function ReadyToaster(props) {
  useEffect(() => { toastHostReady(); }, []);
  return <Toaster {...props} />;
}

/**
 * Mounts the toast renderer only once the first toast is requested, keeping
 * sonner out of the initial JavaScript bundle.
 */
export default function ToastHost(props) {
  const [active, setActive] = useState(false);

  useEffect(() => { registerToastHost(() => setActive(true)); }, []);

  if (!active) return null;

  return (
    <Suspense fallback={null}>
      <ReadyToaster {...props} />
    </Suspense>
  );
}